import { render, staticRenderFns } from "./ExtractDataTypeModal.vue?vue&type=template&id=27b3e330&scoped=true&"
import script from "./ExtractDataTypeModal.vue?vue&type=script&lang=js&"
export * from "./ExtractDataTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b3e330",
  null
  
)

export default component.exports